import {ResponseBase} from "../../data";
import {Register, Template} from "../../data/register";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface RegisterState {
    response: ResponseBase | null
    loading: boolean,
    error: ResponseBase | null,
    requestFinished: boolean,
    templatesList: Template[],
    selectedTemplate: Template,
    registerList: Register[],
}

const initialRegisterState: RegisterState = {
    response: null,
    loading: false,
    error: null,
    requestFinished: false,
    templatesList: [],
    selectedTemplate: {} as Template,
    registerList: [],
}

const registerSlice = createSlice({
    name: 'register',
    initialState: initialRegisterState,
    reducers: {
        setResponse(state, action: PayloadAction<ResponseBase | null>) {
            state.response = action.payload;
            state.loading = false;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setTemplatesList(state, action: PayloadAction<Template[]>) {
            state.templatesList = action.payload;
            state.loading = false;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.loading = false;
            state.error = action.payload;
        },
        setRequestFinished(state, action: PayloadAction<boolean>) {
            state.requestFinished = action.payload;
            state.loading = false;
        },
        setSelectedTemplate(state, action: PayloadAction<Template>) {
            state.selectedTemplate = action.payload;
            state.loading = false;
        },
        setRegisterList(state, action: PayloadAction<Register[]>) {
            state.registerList = action.payload;
            state.loading = false;
        },
    }
});

export const registerActions = registerSlice.actions;
export default registerSlice;
